import {
  Component,
  ViewChild,
  Output,
  EventEmitter,
  Input,
} from "@angular/core";
import { ModalComponent } from "../../components/modal/modal.component";
import * as _ from "underscore";

@Component({
  selector: "lowy-reject-upload",
  template: `
    <lowy-modal #modal>
      <div class="form">
        <span class="link" (click)="modal.close()" *ngIf="!viewOnly"
          ><i class="material-icons">keyboard_backspace</i>cancel</span
        >
        <div class="headline" *ngIf="!viewOnly">Are You Sure?</div>
        <div class="headline" *ngIf="viewOnly">Rejection Reasons</div>
        <div class="subheading" *ngIf="!viewOnly">
          The item you are rejecting will be removed from your queue and no
          longer be available to view.
        </div>

        <ul>
          <li class="row">
            <div class="col-3"><label>Patient ID</label></div>
            <div class="col-9">{{ item?.patientId }}</div>
          </li>
          <li class="row">
            <div class="col-3"><label>Filename</label></div>
            <div class="col-9">{{ item?.fileName }}</div>
          </li>
          <li class="row">
            <div class="col-3"><label>Image Type</label></div>
            <div class="col-9">{{ item?.imageType }}</div>
          </li>
          <li class="row">
            <div class="col-3"><label>Image Platform</label></div>
            <div class="col-9">{{ item?.imagePlatform }}</div>
          </li>
          <li class="row">
            <div class="col-3"><label>Study ID</label></div>
            <div class="col-9">{{ item?.studyId }}</div>
          </li>
        </ul>

        <div class="subheading">Folder issue</div>
        <mat-checkbox
          *ngFor="let reason of folderReasons"
          [(ngModel)]="reason.checked"
          [disabled]="viewOnly"
          >{{ reason.label }}</mat-checkbox
        >
        <div class="seperator"></div>
        <div class="subheading">File issue</div>
        <mat-checkbox
          *ngFor="let reason of fileReasons"
          [(ngModel)]="reason.checked"
          [disabled]="viewOnly"
          >{{ reason.label }}</mat-checkbox
        >
        <div class="seperator"></div>
        <mat-form-field>
          <textarea
            maxlength="400"
            matInput
            placeholder="Comments"
            [(ngModel)]="comments"
            [disabled]="viewOnly"
          ></textarea>
        </mat-form-field>

        <div class="row">
          <div class="col-2">
            <button
              *ngIf="!viewOnly"
              mat-button
              class="lowy-btn-std"
              (click)="doReject()"
            >
              reject
            </button>
            <button
              *ngIf="viewOnly"
              mat-button
              class="lowy-btn-std"
              (click)="modal.close()"
            >
              close
            </button>
          </div>
        </div>
      </div>
    </lowy-modal>
  `,
})
export class RejectUploadComponent {
  @ViewChild("modal") modal: ModalComponent;

  @Output() reject: EventEmitter<any>;

  public item: any;
  private index: number;

  public folderPatientId: boolean;

  public folderReasons: Array<{ label: string; checked: boolean }>;
  public fileReasons: Array<{ label: string; checked: boolean }>;
  public comments: string;

  public viewOnly: boolean;

  constructor() {
    this.reject = new EventEmitter();
  }

  public open(index, checkedItem) {
    this.viewOnly = false;
    this.index = index;
    this.item = checkedItem;
    this.buildForm();
    this.modal.open();
  }

  buildForm() {
    this.folderReasons = [
      { label: "Incorrect patient ID in folder name", checked: false },
      { label: "Incorrect study ID in folder name", checked: false },
      { label: "Incorrect date in folder name", checked: false },
      { label: "Empty folder", checked: false },
    ];

    this.fileReasons = [
      { label: "Incorrect patient ID in file name", checked: false },
      { label: "Incorrect study ID in file name", checked: false },
      { label: "Incorrect image date in file name", checked: false },
      {
        label: "Incorrect patient ID saved within file, itself (eg e2e file)",
        checked: false,
      },
      {
        label:
          "Incorrect study ID saved within file, itself (eg inside e2e file)",
        checked: false,
      },
      {
        label: "Incorrect Date of Birth in file (should be 1/1/1900)",
        checked: false,
      },
      { label: "Patient identifying information within file", checked: false },
    ];

    this.comments = "";
  }

  public doReject() {
    let rejectionText = "";
    const rejectionReasons = {
      folderReasons: [],
      fileReasons: [],
      comments: null,
    };
    this.folderReasons.forEach((reason) => {
      if (reason.checked) {
        rejectionText += reason.label + "<br>";
        rejectionReasons.folderReasons.push(reason.label);
      }
    });
    this.fileReasons.forEach((reason) => {
      if (reason.checked) {
        rejectionText += reason.label + "<br>";
        rejectionReasons.fileReasons.push(reason.label);
      }
    });
    if (this.comments && this.comments.length > 0) {
      rejectionText += "<br>Comments: " + this.comments;
      rejectionReasons.comments = this.comments;
    }
    this.reject.emit({
      index: this.index,
      item: this.item,
      rejectionText: rejectionText,
      rejectionReasons: rejectionReasons,
    });
    this.modal.close();
  }

  viewReasons(entry: {
    rejectionReasons: string;
    patientId: string;
    folderName: string;
    imageType: string;
    imagePlatform: string;
    studyId: string;
  }) {
    this.viewOnly = true;
    this.buildForm();
    // build data
    this.item = {
      patientId: entry.patientId,
      fileName: entry.folderName,
      imageType: entry.imageType,
      imagePlatform: entry.imagePlatform,
      studyId: entry.studyId,
    };
    // fill reasons
    const jsonReasons: {
      comments: string;
      fileReasons: string[];
      folderReasons: string[];
    } = JSON.parse(entry.rejectionReasons);
    // fileReasons
    _.each(jsonReasons.fileReasons, (fileReason) => {
      for (let i = 0; i < this.fileReasons.length; i++) {
        if (this.fileReasons[i].label === fileReason) {
          this.fileReasons[i].checked = true;
        }
      }
    });
    // folderReasons
    _.each(jsonReasons.folderReasons, (folderReason) => {
      for (let i = 0; i < this.folderReasons.length; i++) {
        if (this.folderReasons[i].label === folderReason) {
          this.folderReasons[i].checked = true;
        }
      }
    });
    // comments
    this.comments = jsonReasons.comments;
    this.modal.open();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/reports/reject-modal.component.ts